import PdfViewer from '@/shared/components/PDF';
import {Box} from '@mui/material';
import Loader from '@/shared/components/Loader';
import {formContentStyle} from '@/components/Organization/Dashboard/CreateNewEvent/EventSetting/FormContent/FormContent.styles';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector} from '@/store/organization-event';
import {PrintableService} from '@/utils/services/organization-printables';
import {getDefaultRequestBody, getErrorMessage} from '@/utils/helpers';
import {toast} from 'react-toastify';
import {useEffect, useState} from 'react';
import EmptyContent from '@/shared/components/Table/EmptyContent';
import {ReactComponent as PeopleIcon} from '@/assets/icons/sidebar/people.svg';
import {getAttendeesList, getAttendeesListSelector} from '@/store/organization-attendees';
import {EVENT_ID} from '@/utils/constants';

const GuestByName = () => {
	const dispatch = useAppDispatch();

	const currentEvent = useAppSelector(getCurrentEventSelector);
	const attendees = useAppSelector(getAttendeesListSelector);

	const [pdfData, setPdfData] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	const getQRCode = async () => {
		if (!currentEvent) return;
		setIsLoading(true);

		try {
			const {data} = await PrintableService.getGuestList(currentEvent.id, 'Name');

			if (!data) return;
			const blob = new Blob([data], {type: 'application/pdf'});
			const url = URL.createObjectURL(blob);
			setPdfData(url);
		} catch (error) {
			toast.error(getErrorMessage(error));
		} finally {
			setIsLoading(false);
		}
	};

	const fetchAttendeesList = async () => {
		if (!currentEvent) return;

		try {
			const reqBody = getDefaultRequestBody(currentEvent.id, EVENT_ID);
			await dispatch(getAttendeesList({...reqBody, page: 1, pageSize: 10000})).unwrap();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	useEffect(() => {
		if (!currentEvent) return;

		fetchAttendeesList();
	}, [currentEvent?.id]);

	useEffect(() => {
		getQRCode();
	}, [currentEvent?.id]);

	return (
		<Box>
			{isLoading ? (
				<Box sx={{height: 'calc(100vh - 270px)', position: 'relative'}}>
					<Loader sx={formContentStyle.loader} size={50} />
				</Box>
			) : pdfData && attendees.totalCount ? (
				<PdfViewer fileUrl={pdfData} />
			) : (
				<EmptyContent title="Please add at least one attendee to get guest list" icon={PeopleIcon} />
			)}
		</Box>
	);
};

export default GuestByName;
